import React, { useState, useEffect } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { PrivatePageLayout, PageHeader, PageTableCard } from '../../components/PrivatePage';
import LimitRow from './LimitRow';
import { getLimits, startLimit, stopLimit, deleteLimit } from '../../services/LimitsService';
import Pagination from '../../components/Pagination/Pagination';
import Toast from '../../components/Toast/Toast';
import NewLimitButton from './NewLimitButton';
import LimitModal from './LimitModal';
import LimitDetailsModal from './LimitDetailsModal';

function Limits() {
    const defaultLocation = useLocation();

    function getPage(location) {
        if (!location) location = defaultLocation;
        return new URLSearchParams(location.search).get('page');
    }

    const history = useHistory();

    useEffect(() => {
        return history.listen((location) => {
            setPage(getPage(location));
        });
    }, [history]);

    const [limits, setLimits] = useState([]);
    const [count, setCount] = useState(0);
    const [notification, setNotification] = useState({ type: '', text: '' });
    const [editLimit, setEditLimit] = useState({});
    const [detailsLimitId, setDetailsLimitId] = useState(null);
    const [page, setPage] = useState(getPage());

    useEffect(() => {
        getLimits(page || 1)
            .then((result) => {
                setLimits(result.rows);
                setCount(result.count);
            })
            .catch((err) => {
                console.error(err.response ? err.response.data : err.message);
                setNotification({ type: 'error', text: err.response ? err.response.data : err.message });
            });
    }, [page]);

    function onDetailsClick(event) {
        const id = event.currentTarget.id.replace('details', '');
        setDetailsLimitId(parseInt(id, 10));
    }

    function onEditClick(event) {
        const id = event.target.id.replace('edit', '');
        const limit = limits.find((m) => m.id == id);
        setEditLimit({ ...limit });
    }

    function onStopClick(event) {
        const id = event.target.id.replace('stop', '');
        stopLimit(id)
            .then(() => { history.go(0); })
            .catch((err) => {
                console.error(err.response ? err.response.data : err.message);
                setNotification({ type: 'error', text: err.response ? err.response.data : err.message });
            });
    }

    function onStartClick(event) {
        const id = event.target.id.replace('start', '');
        startLimit(id)
            .then(() => { history.go(0); })
            .catch((err) => {
                console.error(err.response ? err.response.data : err.message);
                setNotification({ type: 'error', text: err.response ? err.response.data : err.message });
            });
    }

    function onDeleteClick(event) {
        const id = event.target.id.replace('delete', '');
        deleteLimit(id)
            .then(() => { history.go(0); })
            .catch((err) => {
                console.error(err.response ? err.response.data : err.message);
                setNotification({ type: 'error', text: err.response ? err.response.data : err.message });
            });
    }

    function onLimitSubmit() {
        history.go(0);
    }

    return (
        <PrivatePageLayout>
            <PageHeader
                eyebrow="Admin"
                title="Limits"
                subtitle="Plan caps for automations, monitors, and backtests."
                actions={<NewLimitButton />}
            />
            <PageTableCard>
                <div className="table-wrapper table-responsive">
                    <table className="table table-hover">
                        <thead>
                            <tr>
                                <th>Name</th>
                                <th>Actions</th>
                            </tr>
                        </thead>
                        <tbody>
                            {limits && limits.length
                                ? limits.map((limit) => (
                                    <LimitRow
                                        key={limit.id}
                                        data={limit}
                                        onDetailsClick={onDetailsClick}
                                        onEditClick={onEditClick}
                                        onStartClick={onStartClick}
                                        onStopClick={onStopClick}
                                        onDeleteClick={onDeleteClick}
                                    />
                                ))
                                : null}
                        </tbody>
                    </table>
                </div>
                <Pagination count={count} />
            </PageTableCard>
            <LimitDetailsModal limitId={detailsLimitId} />
            <LimitModal onSubmit={onLimitSubmit} data={editLimit} />
            <Toast type={notification.type} text={notification.text} />
        </PrivatePageLayout>
    );
}

export default Limits;